<template><div><h1 id="kreditkarten-transaktionen" tabindex="-1"><a class="header-anchor" href="#kreditkarten-transaktionen"><span>Kreditkarten Transaktionen</span></a></h1>
<p>Kreditkarten Transaktionen — Liste aller Kreditkarten-Belastungen mit Status</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Kreditkarten-Belastungen von funtrade werden zentral in dieser Liste abgelegt. Die Liste dient primär einem Protokoll und erlaubt das Nachforschen bei Fehlern.</p>
<p>Pfad:</p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>ID</dt>
<dd>Fortlaufende Transaktionsnummer, wird vom System vergeben.</dd>
<dt>Personen-ID</dt>
<dd>Personen-ID der Person für die Kreditkartenbelastung.</dd>
<dt>Quelle</dt>
<dd>Aktuell existiert nur der Wert &quot;ZUSF&quot; und dieser weist auf die Zusagenfakturierung mit Typ Kreditkarte.</dd>
<dt>Zahlungsv.-ID</dt>
<dd>Zahlungsverbindungs-ID der Person für die Kreditkartenbelastung.</dd>
<dt>Status</dt>
<dd>Status der Transaktion (erfolgreich übermittelt oder fehlerhaft, neu)</dd>
<dt>Status</dt>
<dd>Status der Transaktion:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Neu</td>
<td>Die Transaktion ist neu und wurde noch nicht an den Kreditkartendienst übermittelt.</td>
</tr>
<tr>
<td>Fehlerhaft</td>
<td>Die Transaktion ist fehlerhaft, siehe Feld Details für weitere Informationen.</td>
</tr>
<tr>
<td>Uebermittelt</td>
<td>Die Transaktion wurde erfolgreich an den Kreditkartendienst übermittelt.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Details</dt>
<dd>Bei Status &quot;Fehlerhaft&quot; wird in diesem Feld zusätzliche Information (vom Kreditkartendienst) angezeigt. Dieser Wert kann manuell gelöscht bzw. überschrieben werden. Bei den anderen Status (Neu oder Uebermittelt) kann bei Bedarf ebenfalls ein manueller Eintrag erfasst werden.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>Einzelne Transaktion senden...</dt>
<dd>Bei Status &quot;Neu&quot; oder &quot;Fehlerhaft&quot; kann die Transaktion (nochmals) an den Kreditkartendienst gesendet werden.</dd>
<dt>Alle offene Transaktionen senden...</dt>
<dd>Mit dieser Funktion werden alle offenen Transaktionen, sprich diejenigen mit dem Status &quot;Neu&quot; an den Kreditkartendienst gesendet.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/zusagen.html#Zusagenfakturierung">Zusagenfakturierung</RouteLink></p>
</div></template>


